import React from 'react';
import { SEO } from '../components/SEO';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { breadcrumbSchema } from '../utils/structuredData';
import { ArrowLeftIcon } from 'lucide-react';
export function ImpressumPage() {
  const breadcrumbs = [{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Impressum',
    url: 'https://close-crm-agentur.de/impressum'
  }];
  const structuredData = [breadcrumbSchema(breadcrumbs)];
  return <>
      <SEO title="Impressum" description="Impressum der Close CRM Agentur - Rechtliche Informationen und Kontaktdaten." canonical="https://close-crm-agentur.de/impressum" noindex={true} structuredData={structuredData} data-id="element-480" data-mp="251rizkybkh62" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-481" data-mp="2ss3x5dk5ra53">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-482" data-mp="2sqaltkylo1qr">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-483" data-mp="1u69v9mvqdxx4">
            <div className="flex items-center justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-484" data-mp="1u82zkvivg61y">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0 sm:flex-1" aria-label="Close CRM Agentur Homepage" data-id="element-485" data-mp="1y851n5sir1hr">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-486" data-mp="283ycmkqlamxf">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-487" data-mp="2h6hf33qgqxj5">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-488" data-mp="2lyqz634wd3di">
                  Close CRM Agentur
                </span>
              </a>

              {/* Language Switcher - Always visible */}
              <LanguageSwitcher className="absolute right-3 sm:relative sm:right-0" data-id="element-489" data-mp="2vtss7a2ampld" />

              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-490" data-mp="30sm6h4pemkml">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-491" data-mp="265nb484ib15h" />
                Zurück zur Startseite
              </a>
            </div>
          </nav>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-16" data-id="element-492" data-mp="2g3kx0oyw8lux">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-493" data-mp="2twj8rlvn8qkn">
            <div className="prose prose-invert prose-lg max-w-none" data-id="element-494" data-mp="2tyvp5ulr6svl">
              <h1 className="text-4xl font-bold text-white mb-8" data-id="element-495" data-mp="2oxg25x00mcak">Impressum</h1>

              <div className="space-y-8 text-gray-300" data-id="element-496" data-mp="33u73wcx5w03c">
                <section data-id="element-497" data-mp="2yw5n5yn7kcv1">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-498" data-mp="2yvm0y5qiz2b7">
                    Adresse
                  </h2>
                  <p className="leading-relaxed" data-id="element-499" data-mp="19i0hsj2qbyw9">
                    CRM Kraft LLC
                    <br data-id="element-500" data-mp="14iwbc076wf9m" />
                    Vertreten durch: Justus Kraft
                    <br data-id="element-501" data-mp="3g5q21iv1qst3" />
                    7901 4th St. N, Ste. 300
                    <br data-id="element-502" data-mp="3g7kkmqiui8u0" />
                    St. Petersburg, FL 33702
                    <br data-id="element-503" data-mp="3l39gojvnp7lk" />
                    United States of America
                  </p>
                </section>

                <section data-id="element-504" data-mp="36fem0xy38t5u">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-505" data-mp="3berga3rah2ig">
                    Kontakt
                  </h2>
                  <p className="leading-relaxed" data-id="element-506" data-mp="2xegpt1tw5pxt">
                    Telefon:{' '}
                    <a href="tel:+491745444423" className="text-[#0ea5e9] hover:underline" data-id="element-507" data-mp="31gbr46bto3bl">
                      +49 174 5444423
                    </a>
                    <br data-id="element-508" data-mp="2sf3t7pd7x4i1" />
                    E-Mail:{' '}
                    <a href="mailto:justus@crm-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-509" data-mp="2shqawhttp0dz">
                      justus@crm-kraft.de
                    </a>
                  </p>
                </section>

                <section data-id="element-510" data-mp="2mqvr1c3t8zbb">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-511" data-mp="2hskhz3lcasu5">
                    EU-Streitschlichtung
                  </h2>
                  <p className="leading-relaxed" data-id="element-512" data-mp="2dq7bue2okswu">
                    Die Europäische Kommission stellt eine Plattform zur
                    Online-Streitbeilegung (OS) bereit:{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-513" data-mp="23tcg22xsl6m9">
                      https://ec.europa.eu/consumers/odr/
                    </a>
                    . Unsere E-Mail-Adresse finden Sie oben im Impressum.
                  </p>
                </section>

                <section data-id="element-514" data-mp="1l4e3loym8m2o">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-515" data-mp="1g3i4rpt4fq44">
                    Verbraucherstreitbeilegung/Universalschlichtungsstelle
                  </h2>
                  <p className="leading-relaxed" data-id="element-516" data-mp="3rso8d77vpnts">
                    Wir sind nicht bereit oder verpflichtet, an
                    Streitbeilegungsverfahren vor einer
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-517" data-mp="391djswpmln52">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-518" data-mp="3dyngmxfch12x">
            <p className="text-gray-600 text-sm" data-id="element-519" data-mp="3i0s8bqm8fnmx">
              © {new Date().getFullYear()} Close CRM Agentur. Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </>;
}